import React from "react";
import AmeaInfrastructureProvider from "./AmeaInfrastructureProvider";
import EnvironmentalProvider from "./EnvironmentalProvider";
import MeteoInfoProvider from "./MeteoInfoProvider";
import IndexesProvider from "./IndexesProvider";
import WeatherProvider from "./WeatherProvider";
import AmeaRoutesProvider from "./AmeaRoutesProvider";
import AllSensorsProvider from "./AllSensorsProvider";
import AmeaInfrastructureFiltersProvider from "./AmeaInfrastructureFiltersProvider";
import SensorTypesProvider from "./SensorTypesProvider";
import NewRouteProvider from "./NewRouteProvider";
import UserAuthProvider from "./UserAuthProvider";
import AmeaDataProvider from "./AmeaDataProvider";
import AmeaRoutesCategoriesProvider from "./AmeaRoutesCategoriesProvider";
import BinsProvider from "./BinsProvider";
import HotSpotsProvider from "./HotSpotsProvider";
import FleetProvider from "./FleetProvider";
import HydroProvider from "./HydroProvider";
import HumProvider from "./HumProvider";
import EnergyProvider from "./EnergyProvider";
import ParkingProvider from "./ParkingProvider";

const tilesToProviders = {
  meteo: MeteoInfoProvider,
  info: IndexesProvider,
  infra: AmeaInfrastructureProvider,
  routes: AmeaRoutesProvider,
  weather: WeatherProvider,
  indexes: MeteoInfoProvider,
  all: AllSensorsProvider,
  AmeaFilters: AmeaInfrastructureFiltersProvider,
  sensorTypes: SensorTypesProvider,
  newRouteData: NewRouteProvider,
  auth: UserAuthProvider,
  amea: AmeaDataProvider,
  routesCategories: AmeaRoutesCategoriesProvider,
  bins: BinsProvider,
  hotSpots: HotSpotsProvider,
  fleet: FleetProvider,
  hydro: HydroProvider,
  hum: HumProvider,
  energy: EnergyProvider,
  parking: ParkingProvider,
  environment: EnvironmentalProvider,
};

const AppProviders = ({ children, features }) => {
  return features.reduce((acc, feature) => {
    const Provider = tilesToProviders[feature];
    if (Provider) {
      return <Provider>{acc}</Provider>;
    }
    return acc; // If no matching provider, just return accumulated children
  }, children);
};

export default AppProviders;
